import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FlexContainer } from "../../../constants/assets/containers";
import FilterSearchBar from "../FilterSearchBar";
import OrdersListTable from "../OrdersListTable";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as OrdersActions from "../../../store/actions/Orders";
import ListPagination from "../../Common/ListPagination";
import { isMobile } from "../../../utils";
import { ORDER_STATE_TRIP_CONFIRMED, ORDER_STATES } from "../../../constants/Orders/States";

const OrdersList = ({
  list,
  applyFilters,
  clearFilters,
  getOrdersList,
  nextPage,
  prevPage,
  allFilters,
  filters,
  orderCountByState,
}) => {
  const sortStateOrder = (a, b) => {
    return ORDER_STATES.indexOf(a) - ORDER_STATES.indexOf(b);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [activeIndex, setActiveIndex] = useState(0);

  //handle pagination
  const handleNavClick = (action) => {
    let filters = { ...allFilters };
    if (action === "prev") {
      filters["page"] = prevPage;
      setCurrentPage(prevPage);
      getOrdersList(filters);
    } else {
      filters["page"] = nextPage;
      setCurrentPage(nextPage);
      getOrdersList(filters);
    }
  };

  const handleStateClick = (state, idx) => {
    setActiveIndex(idx);
    const newFilters = {
      page: 1,
      addressFilter: {
        tenant: allFilters?.addressFilter?.tenant,
        city_ids: allFilters?.addressFilter?.city_ids || [],
        locality_ids: allFilters?.addressFilter?.locality_ids || [],
        order_state: state,
      }
    };
    getOrdersList(newFilters);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(allFilters)]);

  useEffect(() => {
    if (filters.page !== currentPage) {
      setCurrentPage(filters.page);
    }
  }, []);

  return (
    <PartnerListContainer align="flex-start">
      <LeftSection>
        <FilterSearchBar
          applyFilters={applyFilters}
          clearFilters={clearFilters}
        />
      </LeftSection>
      <RightSection>
        <StateBar id="stateBar">
          {Object.keys(orderCountByState || {})
            .sort(sortStateOrder)
            .map((state, idx) => {
              const displayState = state === ORDER_STATE_TRIP_CONFIRMED ? "driver_confirmed" : state;
              return (
                <StatCount
                  key={state}
                  active={idx === activeIndex}
                  onClick={() => handleStateClick(state, idx)}
                  className="medium mr-10"
                >
                  {`${displayState.replace('_', ' ')} (${orderCountByState[state]})`}
                </StatCount>
              );
            })}
        </StateBar>
        <OrdersListTable list={list} />
        <ListPagination
          nextPage={nextPage}
          prevPage={prevPage}
          handleNavClick={handleNavClick}
        />
      </RightSection>
    </PartnerListContainer>
  );
};

const PartnerListContainer = styled(FlexContainer)`
  flex-direction: ${isMobile() ? "column" : "row"};
  align-items: ${isMobile() ? "inherit" : "flex-start"};
`;

const LeftSection = styled.div`
  flex: 0 1 30%;
  margin-bottom: ${isMobile() ? "20px" : "unset"};
`;

const RightSection = styled.div`
  flex: 0 1 70%;
  height: calc(100vh - 200px);
  width: 100%;
`;

const StateBar = styled(FlexContainer)`
  margin-left: auto;
  margin-right: 0;
  flex: 0 1 70%;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 20px;
`;

const StatCount = styled.div`
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  background: ${props => props.active ? '#EF4F5F' : '#fff'};
  color: ${props => props.active ? '#fff' : '#000'};
  border: 1px solid ${props => props.active ? '#EF4F5F' : '#E5E7EB'};
`;

function mapStateToProps(state) {
  const { Orders } = state;
  return {
    filters: Orders.Filters,
    nextPage: Orders.NextPage,
    prevPage: Orders.PrevPage,
    orderCountByState: Orders.OrderCountByState
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getOrdersList: bindActionCreators(OrdersActions.getOrdersList, dispatch),
    resetState: bindActionCreators(OrdersActions.resetState, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrdersList);
